import { useCallback } from 'react';
import Router from 'next/router';

import type { FilterQuery } from 'Types/filter';
import ROUTES from 'Utilities/routes';

type UseRefreshVehicleListUrl = () => void;

const useReplaceVehicleListUrl = ({ asUrlPath, displayUrl }: Partial<FilterQuery>): UseRefreshVehicleListUrl => {
	const refreshListUrl = useCallback(() => {
		// This is a temporary fix for the the query string being removed on page load
		// TODO: We should be able to remove this once we've refactored to pass the correct buying format to the FE on load
		const isValidState = asUrlPath !== ROUTES.VEHICLE_LIST.href; // Make sure there's a query
		const isReplaceRouteSameAsCurrentRoute = Router.asPath === displayUrl;

		if (!displayUrl || !asUrlPath || !isValidState || isReplaceRouteSameAsCurrentRoute) {
			return;
		}

		void Router.replace(asUrlPath, displayUrl, { shallow: true });
	}, [asUrlPath, displayUrl]);

	return refreshListUrl;
};

export default useReplaceVehicleListUrl;
